<div class="copy-plan-form-wrapper">
  <form class="standard-form" (ngSubmit)="onSubmit()"
        [formGroup]="copyPlanForm">
    <!---------- HEADER ---------->
    <div class="top-bar" *ngIf="step < 4 || (selectOptionsStep1.length > 0 && step != 5)">
      <div class="center-content">
        <div class="step-bubble" [ngClass]="{'active-step': step <= 1}">1</div>
        <div class="step-bubble-divider"></div>
        <div class="step-bubble" [ngClass]="{'active-step': step === 2}">2</div>
        <div class="step-bubble-divider"></div>
        <div class="step-bubble" [ngClass]="{'active-step': step === 3}">3</div>
        <div class="step-bubble-divider"></div>
        <div class="step-bubble" [ngClass]="{'active-step': step === 4}">4</div>
      </div>
    </div>
    <!---------- STEP 1 ---------->
    <div class="copy-plan-form-main-content step-1" *ngIf="step === 1" [ngClass]="{'active-step': step === 1}">
      <app-loading-panel class="copy-plan-first-load-spinner"></app-loading-panel>
      <div class="copy-plan-form-pmb-section">
        <button sharedMyButton
                type="button"
                class="checkbox-wrapper dropdown-menu"
                (click)="onCbChange($event, 'includeAllFromOldPlan')"
                [class.checked]="cbValues.includeAllFromOldPlan"
                (keydown)="onCbChange($event, 'includeAllFromOldPlan')">
          <div class="checkbox-flex-container">
            <label [class.checked]="cbValues.includeAllFromOldPlan">
              <i *ngIf="cbValues.includeAllFromOldPlan" class="eleot-icon icon-check" aria-hidden="true"></i>
            </label>
          </div>
        </button>
        <p class="checkbox-info">Copy the entire plan with all information from {{oldPlanName}}.</p>
      </div>
      <h3>OR</h3>
      <p>Create a New Plan with information imported from {{oldPlanName}}.</p>
      <h3>Step 1:</h3>
      <p>Please review your current Vision, Mission, and Belief Statements. If there are no changes check the box to include your new plan. Next, add the Priority Statement(s) that will continue to connect to your new plan. Then select "Next" to proceed.</p>
      <h4>Vision, Mission, and Belief Statement</h4>
      <div class="copy-plan-form-pmb-section">
        <button sharedMyButton
                type="button"
                class="checkbox-wrapper dropdown-menu"
                (click)="onCbChange($event, 'includePurposeMissionBeliefs')"
                [class.checked]="cbValues.includePurposeMissionBeliefs"
                (keydown)="onCbChange($event, 'includePurposeMissionBeliefs')">
          <div class="checkbox-flex-container">
            <label [class.checked]="cbValues.includePurposeMissionBeliefs">
              <i *ngIf="cbValues.includePurposeMissionBeliefs" class="eleot-icon icon-check" aria-hidden="true"></i>
            </label>
          </div>
        </button>
        <p class="checkbox-info">Check box to include the Vision, Mission, and Belief Statements</p>
      </div>
      <h4>Add Priority Statement(s)*</h4>
      <app-priority-dropdown
        #copyPlanPrioritySelector
        class="copy-plan-dropdown-selector"
        [showDates]="true"
        maxHeight="300px"
        [singleSelection]="false"
        [availableOptions]="selectOptionsStep1"
        (valueChangedCallback)="onPriorityDropdownSelect($event)"
        [styleOverrides]="{'width': '100%'}"
        [styleClassAppends]="dropdownPanelClass"
        [noDefaultSelection]="true"
        [forceDisable]="false"
        defaultLabel="Select one or more Priority Statements"
        selectedItemsLabel="Priority Statements Selected ({0})"
        selectAllItemsLabel="Select All Priority Statements"
        allItemsSelectedLabel="All Priority Statements Selected ({0})">x
      </app-priority-dropdown>
    </div>
    <!---------- STEP 2 ---------->
    <div class="copy-plan-form-main-content step-2" *ngIf="step === 2" [ngClass]="{'active-step': step === 2}">
      <h3 class="copy-plan-step-4-extra-prompt">Step 2:</h3>
      <ng-container *ngIf="selectOptionsStep2.length === 0">
        <p><strong>Your selections did not result in any available Objective(s). Please select "Next" to proceed.</strong></p>
      </ng-container>
      <ng-container *ngIf="selectOptionsStep2.length > 0">
        <p>Please select Objective(s) that support your chosen Priority Statement(s). Then, select "Next" to proceed.</p>
        <h4>Add Objective(s)</h4>
        <app-priority-dropdown
          #copyPlanObjectiveSelector
          class="copy-plan-dropdown-selector"
          [showDates]="false"
          maxHeight="300px"
          [singleSelection]="false"
          [availableOptions]="selectOptionsStep2"
          (valueChangedCallback)="onObjectiveDropdownSelect($event)"
          [styleOverrides]="{'width': '100%'}"
          [styleClassAppends]="dropdownPanelClass"
          [noDefaultSelection]="true"
          defaultLabel="Select one or more Objective(s)"
          selectedItemsLabel="Objective(s) Selected ({0})"
          selectAllItemsLabel="Select All Objective(s)"
          allItemsSelectedLabel="All Objective(s) Selected ({0})">x
        </app-priority-dropdown>
      </ng-container>
    </div>
    <!---------- STEP 3 ---------->
    <div class="copy-plan-form-main-content step-3" *ngIf="step === 3" [ngClass]="{'active-step': step === 3}">
      <h3 class="copy-plan-step-4-extra-prompt">Step 3:</h3>
      <ng-container *ngIf="selectOptionsStep3.length === 0">
        <p><strong>Your selections did not result in any available Critical Initiative(s). Please select "Next" to proceed.</strong></p>
      </ng-container>
      <ng-container *ngIf="selectOptionsStep3.length > 0">
        <p>Please select Critical Initiative(s) that support your chosen Objective(s). Then, select "Next" to proceed.</p>
        <h4>Add Critical Initiatives(s)</h4>
        <app-priority-dropdown
          #copyPlanInitiativeSelector
          class="copy-plan-dropdown-selector"
          [showDates]="true"
          maxHeight="300px"
          [singleSelection]="false"
          [availableOptions]="selectOptionsStep3"
          (valueChangedCallback)="onInitiativeDropdownSelect($event)"
          [styleOverrides]="{'width': '100%'}"
          [styleClassAppends]="dropdownPanelClass"
          [noDefaultSelection]="true"
          defaultLabel="Select one or more Critical Initiatives(s)"
          selectedItemsLabel="Critical Initiatives(s) Selected ({0})"
          selectAllItemsLabel="Select All Critical Initiatives(s)"
          allItemsSelectedLabel="All Critical Initiatives(s) Selected ({0})">x
        </app-priority-dropdown>

      </ng-container>
    </div>
    <!---------- STEP 4 ---------->
    <div class="copy-plan-form-main-content step-4" *ngIf="step === 4" [ngClass]="{'active-step': step === 4}">
      <ng-container *ngIf="selectOptionsStep1.length > 0">
        <h3 class="copy-plan-step-4-extra-prompt">Step 4:</h3>
      </ng-container>
      <ng-container *ngIf="selectOptionsStep1.length === 0">
        <p class="copy-plan-step-4-extra-prompt">Please complete the below information to copy the following plan:</p>
        <p class="copy-plan-step-4-extra-prompt"><strong>{{strategy.strategyName}}</strong></p>
      </ng-container>
      <p>Please remember to rename your copied plan and select the beginning and end dates for ease of use and identification. Then select "Add New Plan" to complete.</p>
      <label class="standard-label plan-name-label" for="strategyName">Name your Plan*</label>
      <div class="input-error-wrap sans-margin">
        <input auto="name-field" class="standard-input block" type="text" id="strategyName" placeholder="Enter a new plan name" name="strategy name" [formControl]="name" [maxlength]="MAX_NAME_LENGTH">
        <div class="remaining-msg">Remaining: {{ remainingCharacters }}</div>
        <app-error-msg [control]="name" *ngIf="showStrategyNameErrors" [show]="showStrategyNameErrors"></app-error-msg>
      </div>
      <ng-container *ngIf="selectOptionsStep1.length > 0">
        <label class="standard-label" [ngClass]="{'select-dates-label': !showStrategyNameErrors}">Select Target Dates</label>
      </ng-container>
      <ng-container *ngIf="selectOptionsStep1.length === 0">
        <label class="standard-label" [ngClass]="{'select-dates-label': !showStrategyNameErrors}">Select Dates</label>
      </ng-container>
      <div class="flex-date-row" [ngClass]="{'has-errors': showDateErrors}">
        <p-calendar styleClass="copy-modal-calendar"
                    panelStyleClass="copy-modal-calendar"
                    inputStyleClass="standard-input"
                    [formControl]="startDate"
                    placeholder="Start Date"
                    appendTo="body"
                    [(ngModel)]="startDateValue"
                    [showIcon]="true">
        </p-calendar>
        <p-calendar styleClass="copy-modal-calendar"
                    panelStyleClass="copy-modal-calendar"
                    inputStyleClass="standard-input"
                    [formControl]="endDate"
                    placeholder="End Date"
                    appendTo="body"
                    [(ngModel)]="endDateValue"
                    [showIcon]="true"
                    [minDate]="startDate.value">
        </p-calendar>
      </div>
      <div *ngIf="showDateErrors">
        <app-error-msg [control]="endDate" [show]="showDateErrors"></app-error-msg>
      </div>
    </div>
    <!--  STEP 5  -->
    <div class="copy-plan-form-main-content step-5" *ngIf="step === 5" [ngClass]="{'active-step': step === 5}">
      <div class="select-institution-top-row">
        <p>Select institutions below<sup>*</sup>: </p>
        <div class="copy-plan-form-pmb-section select-all">
          <button sharedMyButton
                  type="button"
                  class="checkbox-wrapper dropdown-menu"
                  (click)="allInstitutionSelected = !allInstitutionSelected"
                  [class.checked]="allInstitutionSelected"
                  (keydown)="onSelectAllCbChange($event)">
            <div class="checkbox-flex-container">
              <label [class.checked]="allInstitutionSelected">
                <i *ngIf="allInstitutionSelected" class="eleot-icon icon-check" aria-hidden="true"></i>
              </label>
            </div>
          </button>
          <p class="checkbox-info">Select all</p>
        </div>
      </div>
      <div class="institution-selector-container">
        <div *ngFor="let institution of allInstitutions" class="copy-plan-form-pmb-section">
          <button sharedMyButton
                  type="button"
                  class="checkbox-wrapper dropdown-menu"
                  (click)="onInstitutionCheckboxChange($event, institution)"
                  [class.checked]="institution.selected || allInstitutionSelected"
                  (keydown)="onInstitutionCheckboxChange($event, institution)"
                  [disabled]="allInstitutionSelected"
                  [attr.aria-disabled]="allInstitutionSelected ? true : null"
                  >
            <div class="checkbox-flex-container">
              <label [class.checked]="institution.selected || allInstitutionSelected">
                <i *ngIf="institution.selected || allInstitutionSelected" class="eleot-icon icon-check" aria-hidden="true"></i>
              </label>
            </div>
          </button>
          <p class="checkbox-info">{{institution.name}}<span *ngIf="institution.customerType === 'District'"> - (District Only)</span></p>
        </div>
      </div>
    </div>
    <!---------- FOOTER ---------->
    <div class="copy-plan-form-footer-content">
      <p *ngIf="!noResultsStep && step !== 2 && step !== 3" class="required-info">* Indicates required field</p>
      <div class="copy-plan-nav-buttons">
        <button *ngIf="step > 1 && selectOptionsStep1.length > 0 || (isDistrict && step === 5)"
                class="btn btn-alt"
                type="button"
                [disabled]="((isLoading$ | async) === true)"
                (click)="navBack()">
          Previous
        </button>
        <button *ngIf="step < 4 || isDistrict && step < 5"
                class="btn"
                type="button"
                [disabled]="isNextDisabled || ((isLoading$ | async) === true)"
                (click)="navForward()">
          {{step == 4 ? 'Add New Plan' : 'Next'}}
        </button>
        <button *ngIf="step === 4 && !isDistrict || step == 5"
                class="btn"
                type="submit"
                [disabled]="isSubmitDisabled || ((isLoading$ | async) === true)">
          {{step == 5 ? 'Finish' : 'Add New Plan'}}
        </button>
      </div>
    </div>
  </form>
</div>
